import React from "react";
import { TFunction } from "i18next";
import { Tooltip } from "@mui/material";

import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import { onKeyboardActivate } from "@helpers/a11y";

type Props = {
    row: FidelityRow;
    setFidelity: (row: FidelityRow) => void;
    setIsAddFidelityClicked: (v: boolean) => void;
    setIsConsult: (v: boolean) => void;
    t: TFunction;
};

export default function ConsultIconButton({
    row,
    setFidelity,
    setIsAddFidelityClicked,
    setIsConsult,
    t,
}: Props) {
    const handleClick = () => {
        setFidelity(row);
        setIsAddFidelityClicked(true);
        setIsConsult(true);
    };

    return (
        <Tooltip title={t("To consult")}>
            <div
                data-testid={`fidelity-shops-consult-icon-${row.Id}`}
                role="button"
                tabIndex={0}
                aria-label={t("To consult")}
                onKeyDown={onKeyboardActivate(handleClick)}
            >
                <ConsultSvgIcon
                    className="pointer__clz afa_icn_toConsult"
                    height={35}
                    width={35}
                    style={{ cursor: "pointer", position: "relative" }}
                    fill="black"
                    onClick={handleClick}
                />
            </div>
        </Tooltip>
    );
}
